define([
	"dojo/_base/declare",
	"csi/locale",
	"SiteAdmin/Locale",
	"SiteAdmin/Locale/BusinessObject"
], function(declare,locale,Locale,LBO) {

	return declare(LBO, {
		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			return Locale.getTypeResource(this._getNodeType(ctx), locale.TYPE_PLURAL);
		}
	});
});